export const HIDE_ZERO_PAYMENTS_SETTING_KEY =
  'isHideZeroPaymentsInPaymentHistoryByDefault'

export const shouldHideZeroPaymentsByDefault = (value: unknown) =>
  value !== '0' && value !== 0 && value !== false

export const isZeroPaymentAmount = (value: unknown) => {
  if (value === null || value === undefined || value === '') return false

  const amount = Number(value)
  return Number.isFinite(amount) && amount === 0
}

export const filterZeroAmountPayments = <T extends { amount?: unknown }>(
  payments: T[],
  hideZeroAmountPayments: boolean,
) =>
  hideZeroAmountPayments
    ? payments.filter((payment) => !isZeroPaymentAmount(payment.amount))
    : payments
